import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { RunSchema } from '@/types/schema';
import {
  appOrganizationPath,
  appPlaygroundPath,
  appRunPath,
} from '@/utils/constants';

export function useRunListActions() {
  const organizationId = useOrganizationId();
  const navigate = useNavigate();
  const [deleteOpen, setDeleteOpen] = useState<string | null>(null);
  const [exampleOpen, setExampleOpen] = useState<RunSchema | null>(null);

  const control = { deleteOpen, setDeleteOpen, exampleOpen, setExampleOpen };

  const actions = useMemo(
    () => ({
      handlePlayground(row: RunSchema) {
        navigate(
          `/${appOrganizationPath}/${organizationId}/${appPlaygroundPath}/${appRunPath}/${row.id}`
        );
      },
      handleAddToDataset(row: RunSchema) {
        setExampleOpen(row);
      },

      handleDelete(id: string) {
        setDeleteOpen(id);
      },
    }),
    [navigate]
  );

  return [control, actions] as const;
}
